import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconChevronRight = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M7.70005 22.71L6.30005 21.29L15.78 12L6.30005 2.71004L7.70005 1.29004L18.64 12L7.70005 22.71Z" }))));
};
